import { CmpImpl, CmpPort } from '../../../ports'
import { cmp } from '@otto-ec/eprivacy-cmp'

export class CmpAdapter implements CmpPort {
  cmp(): CmpImpl {
    return cmp
  }
}
